import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@spartacus/core';
import { provideDefaultConfig } from '@spartacus/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Default Adobe Experience Platform Launch collector.
 */
let AepCollectorService = /*#__PURE__*/(() => {
  class AepCollectorService {
    constructor(scriptLoader) {
      this.scriptLoader = scriptLoader;
    }
    /**
     * If the `TmsCollectorConfig.dataLayerProperty` is not specified, it uses the default `digitalData`
     */
    init(config, windowObject) {
      const dataLayerProperty = config.dataLayerProperty ?? 'digitalData';
      windowObject[dataLayerProperty] = windowObject[dataLayerProperty] ?? {};
      if (config.scriptUrl) {
        this.scriptLoader.embedScript({
          src: config.scriptUrl
        });
      }
    }
    pushEvent(config, windowObject, event) {
      const dataLayerProperty = config.dataLayerProperty ?? 'digitalData';
      windowObject[dataLayerProperty] = {
        ...windowObject[dataLayerProperty],
        ...event
      };
    }
    static {
      this.ɵfac = function AepCollectorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AepCollectorService)(i0.ɵɵinject(i1.ScriptLoader));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AepCollectorService,
        factory: AepCollectorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AepCollectorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAdobeExperiencePlatformConfig = {
  tagManager: {
    aep: {
      collector: AepCollectorService
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AepModule = /*#__PURE__*/(() => {
  class AepModule {
    static {
      this.ɵfac = function AepModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AepModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AepModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultAdobeExperiencePlatformConfig)]
      });
    }
  }
  return AepModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AepCollectorService, AepModule };
